import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c080a68a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c080a68a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c080a68a')) {
      api.createRecord('c080a68a', component.options)
    } else {
      api.reload('c080a68a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c080a68a", function () {
      api.rerender('c080a68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/input/IkTableNumberTag/index.vue"
export default component.exports